/**
 * Remounts its child on `retry()`. Used around a player so a Retry starts its pass hook again from
 * scratch (with a fresh error-renewal count). Shared; imports nothing Speedy-specific.
 */
import { Fragment, useCallback, useState, type ReactNode } from 'react';

export function RetryKey({ children }: { children: (attempt: number, retry: () => void) => ReactNode }) {
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  return <Fragment key={attempt}>{children(attempt, retry)}</Fragment>;
}
